import * as React from "react";
import {CSSProperties, ReactNode} from "react";

import {FBColumnOptions} from "./FBColumn.Options";
import {FieldFactory} from "../FieldFactory";
import {FBRow} from "./FBRow";
import {FBFieldBase} from "../Fields/Core/FBFieldBase";
import {FBColumnModel} from "FormBuilder/Core/FBColumn.Model";
import {FBRowModel} from "FormBuilder/Core/FBRow.Model";

export class FBColumn<P extends FBColumnProps=any,S extends FBColumnState=any> extends React.Component<P,S> {
    static defaultProps: Partial<FBColumnProps> = {};
    public FieldDesigner:ReactNode;
    public Field:FBFieldBase;
    constructor(props: P) {
        super(props);
        (this.state as any) = {};
        this.FieldRefUpdated=this.FieldRefUpdated.bind(this);
    }

    componentDidMount(): void {
        this.props.Model.OnRefresh.Subscribe(this,()=>this.forceUpdate());
    }


    componentWillUnmount(): void {
        this.props.Model.OnRefresh.Unsubscribe(this);
    }

    public render() {
        return (
            <div className={'rednaoWooColumn'} style={this.GetColumnStyles()}>
                {FieldFactory.GetField(this.props.Model.Field)}
            </div>
        )
    }

    public GetColumnStyles():CSSProperties
    {
        return {width:this.props.Model.Options.WidthPercentage+'%',display:'inline-block',boxSizing:'border-box',verticalAlign:'top'};
    }

    public get FormBuilder(){
        return this.props.Model.Field.FormBuilder;
    }


    public FieldRefUpdated(x:any){
        this.Field=x;
    }
}


//#region ----------------------------------------------------"State and props"------------------------------------------------------------------------------------
export interface FBColumnProps {
    Model:FBColumnModel;
}

export interface FBColumnState {

}
